import Vue from 'vue';
import YorkbbsDraggable from 'vuedraggable';

Vue.component('YorkbbsDraggable', YorkbbsDraggable);
